const VERTICAL_TRAVERSAL_CATEGORY = [
  "elevator",
  "escalator",
  "stairs",
  "stairs.emergencyexit",
  "ramp",
]
const VERTICAL_KIOSK_BREAKPOINT = "@media (min-height:1920px)"

const Q_AUTOPLAY = "autoplay"
const Q_PARENT_CATEGORY_ID = "parentCategoryId"
const Q_EVENT_GROUP = "group"
const Q_PROMOTION_GROUP = "group"
const Q_SUB_CATEGORY_ID = "subCategoryId"
const Q_ORDINAL = "ordinal"
const Q_FROM_ORDINAL = "from-ordinal"
const Q_VENUE = "venue"
const Q_MAP_VIEW = "mv"
const Q_VIEW_MODE = "view-mode"
const Q_USER_LOCATION = "user-location"

const PROMOTION_TAXONOMY = "promotion-category"

const DINING_TAXONOMY_TAG = "dining"

const GTM_SEARCH_KEYWORD = "search_keyword"
const GTM_CATEGORY_QUICK_SEARCH = "category_quick_search"
const GTM_GET_DIRECTION = "get_direction"
const GTM_VIEW_EVENT_DETAIL = "view_event_detail"
const GTM_VIEW_POST_DETAIL = "view_post_detail"
const GTM_AMENITY_SEARCH = "amenity_search"
const GTM_VIEW_PROMOTION_DETAIL = "view_promotion_detail"
const GTM_VIEW_FEATURE_DETAIL = "view_feature_detail"
const GTM_VIEW_DIRECTORY_CATEGORY = "view_directory_category"
const GTM_NO_RESULT_VALUE = "no result"
const GTM_PROMOTION_LOCATION = "view_promotion_location"
const GTM_EVENT_LOCATION = "view_event_location"
const GTM_POST_LOCATION = "view_post_location"
const GTM_VIEW_DINING_CATEGORY = "view_dining_category"
const GTM_COUNT_KIOSK_USERS = "count_kiosk_users"
const GTM_SURVEY_NEW_SESSION = "survey_new_session"
const GTM_SURVEY_NAVIGATION_EXPERIENCE = "survey_navigation_experience"
const GTM_SURVEY_NAVIGATION_EXPERIENCE_INCOMPLETE =
  "survey_navigation_experience_incomplete"
const GTM_SELECT_LANGUAGE = "select_language"
const GTM_VIEW_POST = "view_post"
const GTM_VIEW_SERVICE = "view_service"
const GTM_VIEW_RESERVATION = "view_reservation"
const GTM_VIEW_RECOMMENDED_MENU = "view_recommended_menu"

const DEVICE_MOBILE = "mobile"
const DEVICE_KIOSK_V = "kiosk-v"
const DEVICE_KIOSK_H = "kiosk-h"

const HOMEPAGE_ANIMATION = "homepage-animation"

const SHOP_PROMOTION_VIEW_MODE = "shop"

const DEFAULT_SEARCH_LIST_ITEM_SECONDARY_TEXT_KEY = [
  "categoryText",
  "floorText",
  "groupText",
]

const DEFAULT_FILTER_VALUE = "ALL"
const DEFAULT_VENUE_FILTER = DEFAULT_FILTER_VALUE

const UPCOMING_EVENT_FILTER_VALUE = "upcoming"
const CURRENT_EVENT_FILTER_VALUE = "current"
const DEFAULT_EVENT_FILTER_VALUE = CURRENT_EVENT_FILTER_VALUE

const UPCOMING_PROMOTION_FILTER_VALUE = "upcoming"
const CURRENT_PROMOTION_FILTER_VALUE = "current"
const DEFAULT_PROMOTION_FILTER_VALUE = CURRENT_PROMOTION_FILTER_VALUE

const DEFAULT_FILTER_OPTIONS = {
  sanitizeValues: [DEFAULT_FILTER_VALUE],
}

const SKELETON_COUNT = 5
const SKELETON_INDEX_TO_REF = SKELETON_COUNT - 1

const MAP_DEFAULT_BEARING_KEY = "map_default_bearing"
const MAP_DEFAULT_ZOOM_KEY = "map_default_zoom"
const MAP_DEFAULT_PITCH_KEY = "map_default_pitch"
const FORCE_VENUE_ID_KEY = "force_venue_id"

const ERROR_STRATEGY = {
  REDIRECT_404: "redirect_404",
  RELOAD: "reload",
  DIALOG: "dialog",
}

const PROMOTION_PAGE_CONFIG = "promotion"
const EVENT_PAGE_CONFIG = "event"
const DINING_PAGE_CONFIG = "dining"

// One Siam
const VENUE_DEVICE_LOCATION_KEY = "venue_device_location"
const VENUE_DEVICE_VIEW_POINT_KEY = "venue_device_view_point"
const VENUE_DEVICE_NAME_KEY = "venue_device_name"

const REFETCH_INTERVAL = {
  short: 15 * 60 * 1000, // 15mins.
  medium: 30 * 60 * 1000, // 30mins.
  long: 60 * 60 * 1000, // 1hr.
}

export {
  // Query String
  Q_AUTOPLAY,
  Q_PARENT_CATEGORY_ID,
  Q_SUB_CATEGORY_ID,
  Q_ORDINAL,
  Q_FROM_ORDINAL,
  Q_VENUE,
  Q_MAP_VIEW,
  Q_VIEW_MODE,
  Q_EVENT_GROUP,
  Q_PROMOTION_GROUP,
  Q_USER_LOCATION,
  // Google Analytics
  GTM_SEARCH_KEYWORD,
  GTM_CATEGORY_QUICK_SEARCH,
  GTM_GET_DIRECTION,
  GTM_VIEW_EVENT_DETAIL,
  GTM_VIEW_POST_DETAIL,
  GTM_AMENITY_SEARCH,
  GTM_VIEW_PROMOTION_DETAIL,
  GTM_VIEW_FEATURE_DETAIL,
  GTM_VIEW_DIRECTORY_CATEGORY,
  GTM_NO_RESULT_VALUE,
  GTM_PROMOTION_LOCATION,
  GTM_EVENT_LOCATION,
  GTM_POST_LOCATION,
  GTM_VIEW_DINING_CATEGORY,
  GTM_COUNT_KIOSK_USERS,
  GTM_SURVEY_NEW_SESSION,
  GTM_SURVEY_NAVIGATION_EXPERIENCE,
  GTM_SURVEY_NAVIGATION_EXPERIENCE_INCOMPLETE,
  GTM_SELECT_LANGUAGE,
  GTM_VIEW_POST,
  GTM_VIEW_SERVICE,
  GTM_VIEW_RESERVATION,
  GTM_VIEW_RECOMMENDED_MENU,
  // Pages
  HOMEPAGE_ANIMATION,
  SHOP_PROMOTION_VIEW_MODE,
  // Filters
  DEFAULT_VENUE_FILTER,
  DEFAULT_FILTER_VALUE,
  DEFAULT_FILTER_OPTIONS,
  UPCOMING_EVENT_FILTER_VALUE,
  CURRENT_EVENT_FILTER_VALUE,
  DEFAULT_EVENT_FILTER_VALUE,
  UPCOMING_PROMOTION_FILTER_VALUE,
  CURRENT_PROMOTION_FILTER_VALUE,
  DEFAULT_PROMOTION_FILTER_VALUE,
  // Page Configs
  PROMOTION_PAGE_CONFIG,
  EVENT_PAGE_CONFIG,
  DINING_PAGE_CONFIG,
  // Others
  DEVICE_MOBILE,
  DEVICE_KIOSK_V,
  DEVICE_KIOSK_H,
  DEFAULT_SEARCH_LIST_ITEM_SECONDARY_TEXT_KEY,
  PROMOTION_TAXONOMY,
  VERTICAL_TRAVERSAL_CATEGORY,
  VERTICAL_KIOSK_BREAKPOINT,
  SKELETON_COUNT,
  SKELETON_INDEX_TO_REF,
  MAP_DEFAULT_BEARING_KEY,
  MAP_DEFAULT_ZOOM_KEY,
  MAP_DEFAULT_PITCH_KEY,
  FORCE_VENUE_ID_KEY,
  ERROR_STRATEGY,
  DINING_TAXONOMY_TAG,
  // One Siam
  REFETCH_INTERVAL,
  VENUE_DEVICE_LOCATION_KEY,
  VENUE_DEVICE_VIEW_POINT_KEY,
  VENUE_DEVICE_NAME_KEY,
}
